<template>
    <el-card class="fitness-index">
        <div class="search-divp flex items-center">
            <el-input
                class="search-input"
                v-model="form.keyword"
                :placeholder="$t('Reception.Second.search_placeholder')">
            </el-input>
            <div class="pl-6">
                <el-button type="primary" @click="fetchData">{{ $t('Common.search') }}</el-button>
                <el-button type="primary" @click="handleReset">{{ $t('Common.clear') }}</el-button>
            </div>
        </div>
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
            >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="id" :label="$t('Card.client_id')" align="center" width="60px" v-if="false"/>
            <el-table-column prop="salesProtectDays" :label="$t('Reception.Second.day')" align="center" width="80px"/>
            <el-table-column prop="createdAt" :label="$t('Client.entry_date')" align="center" width="100px"/>
            <el-table-column prop="mshpSalesNickname" :label="$t('Common.saler')" align="center" width="105px"/>
            <el-table-column prop="contactTime" :label="$t('Member.Reserved_conta_ttime')" align="center" width="100px"/>
            <el-table-column prop="salesFollowAt" :label="$t('Member.Follow.last_date')" align="center" width="100px"/>
            <el-table-column prop="daysBetweenPreFollow" :label="$t('Member.Final_followup')" align="center"/>
            <el-table-column prop="followCountAftMshp" :label="$t('Client.after_flowup_Num')" align="center" />
            <el-table-column prop="mshpAt" :label="$t('Client.AdmissionTime')" align="center" width="100px"/>
            <el-table-column prop="daysBetweenPreTrain" :label="$t('Client.last_training')" align="center" width="100px"/>
            <el-table-column prop="expiredDays" :label="$t('Member.Days_of_expiration')" align="center" width="100px"/>
            <el-table-column prop="name" :label="$t('Card.client_name')" align="center"/>
            <el-table-column prop="gender" :label="$t('Common.gender')" align="center" width="50px"/>
            <el-table-column prop="phone" :label="$t('Common.phone_number')" align="center" width="110px"/>
            <el-table-column prop="cardNames" :label="$t('Card.CardType')" align="center"/>
            <el-table-column prop="salesFollowStatus" :label="$t('Member.Follow.table_coach_status')" align="center"/>
            <el-table-column prop="clientTagNames" :label="$t('Client.Add.customer_label')" align="center"/>
            <el-table-column prop="activeName" :label="$t('Client.Add.status')" align="center"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
            >
        </el-pagination>
    </el-card>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    props: ['activeName', 'ids'],
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            clients: [],
            form: {
                keyword: '',
                page: 1,
            },
            totalCount: 0,
            potentialClientCount: 0,
            fullPercent: '',
            fullClientCount: 0,
            loading: false,
            tableData: [],
            clientIds: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            is_collapse: false,
        };
    },
    computed: {},
    mounted() {},
    watch: {
        activeName(val) {
            if (val === 'fifth') this.fetchData();
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('client/sales-follow-full', {
                params: { ...this.form },
            })
                .then(res => {
                    this.tableData = res.content;
                    this.pagination.total = res.totalElements;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        say(data) {
            this.form = data;
            this.fetchData();
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.clientIds = val.map(el => el.id);
            this.clients = val;
            this.$emit('listenClientIds', this.clients);
        },
    },
    created() {
        if (this.activeName === 'fifth') this.fetchData();
    },
};
</script>
<style lang="scss">
.title {
  width: 98%;
}
.title-3a {
  height: 30px;
  color: grey;
  line-height: 50px;
  font-size: 12px;
  font-weight: 400;
}
.search-divpp {
  position: absolute !important;
  left: 20px;
  top: 10px;
  bottom: 20px;
  padding-bottom: 15px;
}
.search-input {
  width: 300px;
}
</style>
